import { Get, Post } from "./apiHelper";
import { IServiceTag } from "../interfaces/ServiceTagsInterface";

const serviceTagsRoot = "/api/serviceTags";

// eslint-disable-next-line import/prefer-default-export
export async function getServiceTags(): Promise<Array<IServiceTag>> {
  const response = await Get(`${serviceTagsRoot}`, true);
  return response?.data as Array<IServiceTag>;
}

export async function postServiceTag(serviceTag: Partial<IServiceTag>): Promise<IServiceTag> {
  const response = await Post(`${serviceTagsRoot}`, serviceTag, true);
  return response.data as IServiceTag;
}
